(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-article-2026"]) return;
  try {
    
(() => {
  const initializeArticle = (root) => {
    if (root.dataset.articleReady) return;
    root.dataset.articleReady = 'true';
    const content = root.querySelector('[data-article-content]');
    const sidebar = root.querySelector('[data-article-toc]');
    if (content && sidebar) {
      const headings = [...content.querySelectorAll('h2,h3')].filter((heading) => heading.textContent.trim());
      const list = sidebar.querySelector('[data-toc-list]');
      const details = sidebar.querySelector('details');
      if (headings.length && list && details) {
        const tocLinks = new Map();
        headings.forEach((heading, index) => {
          if (!heading.id || document.getElementById(heading.id) !== heading) {
            let id = 'lectura-' + root.dataset.articleId + '-' + (index + 1);
            let suffix = 1;
            while (document.getElementById(id)) id = 'lectura-' + root.dataset.articleId + '-' + (index + 1) + '-' + suffix++;
            heading.id = id;
          }
          const item = document.createElement('li');
          if (heading.tagName === 'H3') item.className = 'ia-toc__sub';
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          link.addEventListener('click', () => {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
            if (!window.matchMedia('(min-width:990px)').matches) details.open = false;
          });
          item.appendChild(link);
          list.appendChild(item);
          tocLinks.set(heading.id, link);
        });
        details.open = window.matchMedia('(min-width:990px)').matches;
        sidebar.hidden = false;
        try {
          const requestedId = decodeURIComponent(window.location.hash.slice(1));
          const requestedHeading = headings.find((heading) => heading.id === requestedId);
          if (requestedHeading) requestAnimationFrame(() => requestedHeading.scrollIntoView({ block: 'start' }));
        } catch {}
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
            if (!visible.length) return;
            tocLinks.forEach((link, id) => {
              if (id === visible[0].target.id) link.setAttribute('aria-current', 'true');
              else link.removeAttribute('aria-current');
            });
          }, { rootMargin: '-135px 0px -60% 0px', threshold: 0 });
          headings.forEach((heading) => observer.observe(heading));
          const cleanupObserver = (event) => {
            if (event.target.contains(root)) {
              observer.disconnect();
              document.removeEventListener('shopify:section:unload', cleanupObserver);
            }
          };
          document.addEventListener('shopify:section:unload', cleanupObserver);
        }
      }
    }
    const share = root.querySelector('[data-article-share]');
    const shareStatus = root.querySelector('[data-share-status]');
    const copyField = root.querySelector('[data-copy-field]');
    if (share && shareStatus && copyField) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        const url = root.dataset.shareUrl;
        copyField.hidden = false;
        shareStatus.textContent = root.dataset.copyManual;
        if (navigator.clipboard?.writeText) {
          try { await navigator.clipboard.writeText(url); copyField.hidden = true; shareStatus.textContent = root.dataset.copySuccess; return; }
          catch {}
        }
        copyField.hidden = false;
        const input = copyField.querySelector('input');
        input.focus();
        input.select();
        shareStatus.textContent = root.dataset.copyManual;
      });
    }
  };
  document.querySelectorAll('[data-ingenio-article]').forEach(initializeArticle);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ingenio-article]').forEach(initializeArticle));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-collection-proof-2026"]) return;
  try {
    
(() => {
  const bindCollectionReviews = (root) => {
    root.querySelectorAll('.ic-confidence__more').forEach((details) => {
      if (details.dataset.collectionReviewsBound) return;
      details.dataset.collectionReviewsBound = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      });
    });
  };
  bindCollectionReviews(document);
  document.addEventListener('shopify:section:load', (event) => bindCollectionReviews(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-destacados-alternativa"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ingenio-destacados-alt')) {
  customElements.define('ingenio-destacados-alt', class extends HTMLElement {
    connectedCallback() {
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
        window.location.reload();
        return;
      }
      this.controller = new AbortController();
      this.morePages = [];
      this.buttons = Array.from(this.querySelectorAll('[data-selection]'));
      this.results = this.querySelector('[data-selection-results]');
      this.selection = this.results.dataset.key;
      this.baseURL = this.cleanURL(window.location.href);
      this.addEventListener('click', event => this.handleClick(event), { signal: this.controller.signal });
      this.addEventListener('submit', event => {
        if (event.target.closest('[data-destacados-card]')) this.trackProduct('destacados_add_to_cart_click', event.target);
      }, { signal: this.controller.signal });
      this.querySelectorAll('.idc-explore__group').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) this.querySelectorAll('.idc-explore__group').forEach(other => { if (other !== details) other.open = false; });
        }, { signal: this.controller.signal });
      });
      window.addEventListener('popstate', () => {
        if (this.cleanURL(window.location.href).href !== this.baseURL.href) this.loadSelection(window.location.href, { history: false });
      }, { signal: this.controller.signal });
      window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); }, { signal: this.controller.signal });
      this.reviewObserver = new MutationObserver(() => this.syncReviews());
      this.reviewObserver.observe(this.querySelector('.idc-reviews__app'), { childList: true, subtree: true });
      this.updateSelection();
      this.syncReviews();
      this.restoreSelection();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.reviewObserver?.disconnect();
    }
    cleanURL(value) {
      const url = new URL(value, window.location.origin);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.hash = 'DestacadosSelection';
      return url;
    }
    groupFromURL(url) {
      const base = this.dataset.viewBase;
      const view = url.searchParams.get('view') || base;
      return view === base ? 'vendidos' : view.replace(base + '-', '');
    }
    handleClick(event) {
      const guidedIntent = event.target.closest('[data-guide-intent]');
      const guideBack = event.target.closest('[data-guide-back]');
      if (guidedIntent && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        this.guideIntent = guidedIntent.dataset.guideIntent;
        this.querySelector('[data-guide-step-one]').hidden = true;
        this.querySelector('[data-guide-step-two]').hidden = false;
        let question = '';
        this.querySelectorAll('[data-guide-options]').forEach(panel => {
          panel.hidden = panel.dataset.guideOptions !== this.guideIntent;
          if (!panel.hidden) question = panel.dataset.question;
        });
        const heading = this.querySelector('[data-guide-question]');
        heading.textContent = question;
        heading.focus({ preventScroll: true });
        this.querySelector('#DestacadosGuide').scrollIntoView({ behavior: 'auto', block: 'start' });
        this.track('destacados_guide_step', { step: 1, moment: this.guideIntent });
        return;
      }
      if (guideBack) {
        this.querySelector('[data-guide-step-two]').hidden = true;
        this.querySelector('[data-guide-step-one]').hidden = false;
        this.querySelectorAll('[data-guide-intent]').forEach(link => {
          if (link.dataset.guideIntent === this.guideIntent) link.focus({ preventScroll: true });
        });
        return;
      }
      const choice = event.target.closest('[data-selection], [data-selection-more]');
      if (choice && this.contains(choice) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        const append = choice.hasAttribute('data-selection-more');
        this.loadSelection(choice.href, { append });
        return;
      }
      const productLink = event.target.closest('[data-destacados-product]');
      if (productLink) {
        this.trackProduct('destacados_product_click', productLink);
        try {
          sessionStorage.setItem(this.dataset.viewBase + '-return', JSON.stringify({ url: this.baseURL.href, pages: this.morePages, scrollY: window.scrollY, time: Date.now() }));
        } catch (_) {  }
      }
    }
    async loadSelection(value, { append = false, history = true, restoring = false } = {}) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const url = this.cleanURL(value);
      const context = new URL(window.location.href);
      for (const [key, val] of context.searchParams) {
        if (key === 'preview_theme_id' || key.startsWith('utm_') || ['gclid', 'fbclid'].includes(key)) url.searchParams.set(key, val);
      }
      const key = this.groupFromURL(url);
      if (!this.buttons.some(button => button.dataset.selection === key)) return;
      const expectedPage = append ? Number(this.results.dataset.page) + 1 : null;
      const status = this.querySelector('[data-selection-status]');
      const error = this.querySelector('[data-selection-error]');
      error.hidden = true;
      status.textContent = this.dataset.loadingLabel;
      status.dataset.loading = 'true';
      this.results.setAttribute('aria-busy', 'true');
      const timeout = window.setTimeout(() => request.abort(), 15000);
      try {
        const endpoint = new URL(url);
        endpoint.hash = '';
        if (append) endpoint.searchParams.set('section_id', this.results.dataset.renderSection);
        const response = await fetch(endpoint.href, { signal: request.signal, credentials: 'same-origin' });
        let doc = response.ok ? new DOMParser().parseFromString(await response.text(), 'text/html') : null;
        let incoming = doc?.querySelector('[data-selection-results]');
        if (!incoming || incoming.dataset.key !== key || (expectedPage && Number(incoming.dataset.page) !== expectedPage)) {
          const fallback = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
          if (!fallback.ok) throw new Error('Selection unavailable');
          doc = new DOMParser().parseFromString(await fallback.text(), 'text/html');
          incoming = doc.querySelector('[data-selection-results]');
        }
        if (!incoming || incoming.dataset.key !== key || (expectedPage && Number(incoming.dataset.page) !== expectedPage)) throw new Error('Invalid selection');
        if (request !== this.request) return false;
        let firstAdded;
        if (append) {
          const grid = this.results.querySelector('.idc-grid');
          const existing = new Set(Array.from(grid.children, card => card.dataset.productId));
          incoming.querySelectorAll('[data-destacados-card]').forEach(card => {
            if (!existing.has(card.dataset.productId)) {
              if (!firstAdded) firstAdded = card;
              existing.add(card.dataset.productId);
              grid.append(card);
            }
          });
          this.results.querySelector('[data-selection-pagination]').replaceWith(incoming.querySelector('[data-selection-pagination]'));
          this.results.dataset.page = incoming.dataset.page;
          this.results.dataset.total = incoming.dataset.total;
          this.morePages.push(url.href);
        } else {
          this.results.replaceWith(incoming);
          this.results = incoming;
          this.selection = key;
          this.morePages = [];
          this.baseURL = url;
          if (history && url.href !== window.location.href) window.history.pushState({ destacados: key }, '', url);
          this.querySelectorAll('.idc-explore__group').forEach(details => { details.open = false; });
        }
        this.updateSelection();
        status.textContent = this.results.querySelector('[data-destacados-count]').textContent;
        if (!restoring) {
          const focus = append ? firstAdded?.querySelector('h3 a') : this.results.querySelector('[data-selection-heading]');
          focus?.focus({ preventScroll: true });
          if (append) firstAdded?.scrollIntoView({ behavior: 'auto', block: 'start' });
          else this.querySelector('#DestacadosSelection').scrollIntoView({ behavior: 'auto', block: 'start' });
          this.track(append ? 'destacados_load_more' : 'destacados_intent_select', { intent: key, selection: key, count: this.results.querySelectorAll('[data-destacados-card]').length });
        }
        return true;
      } catch (_) {
        if (request !== this.request) return false;
        status.textContent = '';
        error.querySelector('p').textContent = this.dataset.loadError;
        error.querySelector('[data-selection-fallback]').href = url.href;
        error.hidden = false;
        return false;
      } finally {
        window.clearTimeout(timeout);
        if (request === this.request) {
          this.results.setAttribute('aria-busy', 'false');
          status.dataset.loading = 'false';
        }
      }
    }
    updateSelection() {
      this.buttons.forEach(button => button.setAttribute('aria-current', String(button.dataset.selection === this.selection)));
      const count = this.results.querySelectorAll('[data-destacados-card]').length;
      const counter = this.results.querySelector('[data-destacados-count]');
      counter.textContent = this.dataset.countTemplate.replace('[count]', String(count)).replace('[total]', this.results.dataset.total);
      const next = this.results.querySelector('[data-selection-more]');
      if (next) {
        const url = this.cleanURL(next.href);
        url.searchParams.set('view', this.selection === 'vendidos' ? this.dataset.viewBase : this.dataset.viewBase + '-' + this.selection);
        next.href = url.href;
      }
    }
    async restoreSelection() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.dataset.viewBase + '-return') || 'null');
        if (!saved || Date.now() - saved.time > 1800000 || this.cleanURL(saved.url).href !== this.baseURL.href) return;
        sessionStorage.removeItem(this.dataset.viewBase + '-return');
        for (let index = 0; index < saved.pages.length; index += 1) {
          const next = this.results.querySelector('[data-selection-more]');
          if (!next || !await this.loadSelection(next.href, { append: true, history: false, restoring: true })) return;
        }
        window.scrollTo(0, saved.scrollY);
      } catch (_) {  }
    }
    trackProduct(event, element) {
      const card = element.closest('[data-destacados-card]');
      if (card) this.track(event, { intent: this.selection, selection: this.selection, product_id: card.dataset.productId, position: Number(card.dataset.position) });
    }
    track(event, properties) {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, landing_version: this.dataset.viewBase, ...properties });
    }
    syncReviews() {
      const reviews = this.querySelector('.idc-reviews__app .jdgm-carousel-item');
      const score = Number(this.querySelector('.jdgm-all-reviews-rating')?.dataset.score);
      const count = Number(this.querySelector('.jdgm-carousel-number-of-reviews')?.dataset.numberOfReviews);
      const summary = this.querySelector('.jdgm-carousel-number-of-reviews a');
      if (summary && score > 0 && count > 0) {
        const locale = document.documentElement.lang || 'es';
        const text = this.dataset.ratingTemplate.replace('[rating]', score.toLocaleString(locale, { maximumFractionDigits: 2 })).replace('[count]', count.toLocaleString(locale));
        if (summary.textContent !== text) summary.textContent = text;
        this.querySelectorAll('[data-reviews-summary]').forEach(item => { if (item.textContent !== text) item.textContent = text; });
      }
      this.querySelector('.jdgm-carousel__left-arrow')?.setAttribute('aria-label', this.dataset.reviewPrevious);
      this.querySelector('.jdgm-carousel__right-arrow')?.setAttribute('aria-label', this.dataset.reviewNext);
      this.querySelector('[data-destacados-review-fallback]').hidden = Boolean(reviews);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-destacados"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ingenio-destacados')) {
  customElements.define('ingenio-destacados', class extends HTMLElement {
    connectedCallback() {
      // The theme's cart drawer must be refreshed after returning from a product page.
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
        window.location.reload();
        return;
      }
      this.controller = new AbortController();
      this.morePages = [];
      this.buttons = Array.from(this.querySelectorAll('[data-selection]'));
      this.results = this.querySelector('[data-selection-results]');
      this.selection = this.results.dataset.key;
      this.baseURL = this.cleanURL(window.location.href);
      this.addEventListener('click', event => this.handleClick(event), { signal: this.controller.signal });
      this.addEventListener('submit', event => {
        if (event.target.closest('[data-destacados-card]')) this.trackProduct('destacados_add_to_cart_click', event.target);
      }, { signal: this.controller.signal });
      window.addEventListener('popstate', () => {
        // In-page anchors also dispatch popstate; keep reviews and FAQs in place.
        if (this.cleanURL(window.location.href).href !== this.baseURL.href) this.loadSelection(window.location.href, { history: false });
      }, { signal: this.controller.signal });
      window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); }, { signal: this.controller.signal });
      this.reviewObserver = new MutationObserver(() => this.syncReviews());
      this.reviewObserver.observe(this.querySelector('.idc-reviews__app'), { childList: true, subtree: true });
      this.updateSelection();
      this.setupExplore();
      this.setupStories();
      this.syncReviews();
      this.restoreSelection();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.reviewObserver?.disconnect();
      this.exploreObserver?.disconnect();
      this.storyObserver?.disconnect();
      cancelAnimationFrame(this.storyFrame);
    }
    setupExplore() {
      this.explore = this.querySelector('.idc-explore');
      this.exploreControls = this.querySelector('[data-explore-controls]');
      if (!this.explore || !this.exploreControls) return;
      this.exploreButtons = Array.from(this.exploreControls.querySelectorAll('[data-explore-scroll]'));
      this.explore.addEventListener('scroll', () => this.syncExplore(), { passive: true, signal: this.controller.signal });
      this.exploreButtons.forEach(button => button.addEventListener('click', () => {
        this.explore.scrollBy({ left: Number(button.dataset.exploreScroll) * this.explore.clientWidth * .8, behavior: this.motion() });
      }, { signal: this.controller.signal }));
      this.exploreObserver = new ResizeObserver(() => this.revealSelection());
      this.exploreObserver.observe(this.explore);
      this.revealSelection();
    }
    syncExplore() {
      if (!this.explore || !this.exploreControls) return;
      const rail = this.explore;
      this.exploreControls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
      this.exploreButtons.forEach(button => {
        button.disabled = Number(button.dataset.exploreScroll) < 0 ? rail.scrollLeft < 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      });
    }
    revealSelection() {
      const rail = this.explore;
      const active = rail?.querySelector('[aria-current="true"]');
      if (active) {
        const bounds = rail.getBoundingClientRect();
        const item = active.getBoundingClientRect();
        if (item.left < bounds.left || item.right > bounds.right) rail.scrollLeft += item.left - bounds.left - (rail.clientWidth - item.width) / 2;
      }
      this.syncExplore();
    }
    motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    setupStories() {
      this.stories = this.querySelector('[data-stories]');
      this.storyRail = this.stories?.querySelector('[data-story-rail]');
      if (!this.storyRail) return;
      this.storySlides = Array.from(this.storyRail.querySelectorAll('[data-story]'));
      if (!this.storySlides.length) return;
      this.stories.classList.add('is-enhanced');
      this.storyRail.tabIndex = 0;
      this.stories.querySelector('[data-story-controls]').hidden = this.storySlides.length < 2;
      this.stories.querySelectorAll('[data-story-step]').forEach(button => button.addEventListener('click', () => {
        this.showStory(this.storyIndex + Number(button.dataset.storyStep));
      }, { signal: this.controller.signal }));
      this.storyRail.addEventListener('keydown', event => {
        const targets = { ArrowLeft: this.storyIndex - 1, ArrowRight: this.storyIndex + 1, Home: 0, End: this.storySlides.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.showStory(targets[event.key]);
      }, { signal: this.controller.signal });
      this.storyRail.addEventListener('scroll', () => {
        if (this.storyFrame) return;
        this.storyFrame = requestAnimationFrame(() => {
          this.storyFrame = null;
          this.syncStory(Math.round(this.storyRail.scrollLeft / this.storyRail.clientWidth));
        });
      }, { passive: true, signal: this.controller.signal });
      this.storyObserver = new ResizeObserver(() => this.showStory(this.storyIndex || 0, 'auto'));
      this.storyObserver.observe(this.storyRail);
      this.addEventListener('shopify:block:select', event => {
        const index = this.storySlides.indexOf(event.target.closest('[data-story]'));
        if (index >= 0) this.showStory(index, 'auto');
      }, { signal: this.controller.signal });
      this.syncStory(0);
    }
    showStory(index, behavior = this.motion()) {
      const next = Math.max(0, Math.min(this.storySlides.length - 1, index));
      if (this.storySlides.some(slide => slide.contains(document.activeElement))) this.storyRail.focus({ preventScroll: true });
      this.storyRail.scrollTo({ left: next * this.storyRail.clientWidth, behavior });
      if (behavior === 'auto') this.syncStory(next);
    }
    syncStory(index) {
      index = Math.max(0, Math.min(this.storySlides.length - 1, index));
      this.storyIndex = index;
      this.storySlides.forEach((slide, position) => {
        const inactive = position !== index;
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      });
      const counter = this.stories.querySelector('[data-story-counter]');
      counter.textContent = this.stories.dataset.counterTemplate.replace('[index]', String(index + 1)).replace('[total]', String(this.storySlides.length));
      this.stories.querySelector('[data-story-step="-1"]').disabled = index === 0;
      this.stories.querySelector('[data-story-step="1"]').disabled = index === this.storySlides.length - 1;
    }

    cleanURL(value) {
      const url = new URL(value, window.location.origin);
      url.searchParams.delete('section_id');
      url.searchParams.delete('sections');
      url.hash = 'DestacadosSelection';
      return url;
    }
    groupFromURL(url) {
      const view = url.searchParams.get('view') || 'destacados-cro';
      const key = view === 'destacados-cro' ? 'vendidos' : view.replace('destacados-cro-', '');
      return key === 'multiformas' ? 'madera' : key;
    }
    handleClick(event) {
      const choice = event.target.closest('[data-selection], [data-selection-more]');
      if (choice && this.contains(choice) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        const append = choice.hasAttribute('data-selection-more');
        this.loadSelection(choice.href, { append });
        return;
      }
      const productLink = event.target.closest('[data-destacados-product]');
      if (productLink) {
        this.trackProduct('destacados_product_click', productLink);
        try {
          sessionStorage.setItem('ingenio-destacados-return', JSON.stringify({ url: this.baseURL.href, pages: this.morePages, scrollY: window.scrollY, time: Date.now() }));
        } catch (_) { /* Browsing still works with storage disabled. */ }
      }
    }
    async loadSelection(value, { append = false, history = true, restoring = false } = {}) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const url = this.cleanURL(value);
      // Keep a draft preview, locale and campaign context across all selection links.
      const context = new URL(window.location.href);
      for (const [key, val] of context.searchParams) {
        if (key === 'preview_theme_id' || key.startsWith('utm_') || ['gclid', 'fbclid'].includes(key)) url.searchParams.set(key, val);
      }
      const key = this.groupFromURL(url);
      if (!this.dataset.selectionKeys.split(',').includes(key)) return;
      const expectedPage = append ? Number(this.results.dataset.page) + 1 : null;
      const status = this.querySelector('[data-selection-status]');
      const error = this.querySelector('[data-selection-error]');
      error.hidden = true;
      status.textContent = this.dataset.loadingLabel;
      status.dataset.loading = 'true';
      this.results.setAttribute('aria-busy', 'true');
      const timeout = window.setTimeout(() => request.abort(), 15000);
      try {
        const endpoint = new URL(url);
        endpoint.hash = '';
        // Each JSON template owns its pagination key. On a group change, obtain
        // that template's real section ID; subsequent pages need only the section.
        if (append) endpoint.searchParams.set('section_id', this.results.dataset.renderSection);
        const response = await fetch(endpoint.href, { signal: request.signal, credentials: 'same-origin' });
        let doc = response.ok ? new DOMParser().parseFromString(await response.text(), 'text/html') : null;
        let incoming = doc?.querySelector('[data-selection-results]');
        // Full-page fallback keeps links usable if Shopify cannot render this section in another template context.
        if (!incoming || incoming.dataset.key !== key || (expectedPage && Number(incoming.dataset.page) !== expectedPage)) {
          const fallback = await fetch(url.href, { signal: request.signal, credentials: 'same-origin' });
          if (!fallback.ok) throw new Error('Selection unavailable');
          doc = new DOMParser().parseFromString(await fallback.text(), 'text/html');
          incoming = doc.querySelector('[data-selection-results]');
        }
        if (!incoming || incoming.dataset.key !== key || (expectedPage && Number(incoming.dataset.page) !== expectedPage)) throw new Error('Invalid selection');
        if (request !== this.request) return false;
        let firstAdded;
        if (append) {
          const grid = this.results.querySelector('.idc-grid');
          const existing = new Set(Array.from(grid.children, card => card.dataset.productId));
          incoming.querySelectorAll('[data-destacados-card]').forEach(card => {
            if (!existing.has(card.dataset.productId)) {
              if (!firstAdded) firstAdded = card;
              existing.add(card.dataset.productId);
              grid.append(card);
            }
          });
          this.results.querySelector('[data-selection-pagination]').replaceWith(incoming.querySelector('[data-selection-pagination]'));
          this.results.dataset.page = incoming.dataset.page;
          this.results.dataset.total = incoming.dataset.total;
          this.morePages.push(url.href);
        } else {
          this.results.replaceWith(incoming);
          this.results = incoming;
          this.selection = key;
          this.morePages = [];
          this.baseURL = url;
          if (history && url.href !== window.location.href) window.history.pushState({ destacados: key }, '', url);
          this.querySelectorAll('.idc-explore__group').forEach(details => { details.open = false; });
        }
        this.updateSelection();
        status.textContent = this.results.querySelector('[data-destacados-count]').textContent;
        if (!restoring) {
          const focus = append ? firstAdded?.querySelector('h3 a') : this.results.querySelector('[data-selection-heading]');
          focus?.focus({ preventScroll: true });
          if (append) firstAdded?.scrollIntoView({ behavior: 'auto', block: 'start' });
          else this.querySelector('#DestacadosSelection').scrollIntoView({ behavior: 'auto', block: 'start' });
          this.track(append ? 'destacados_load_more' : 'destacados_intent_select', { intent: key, selection: key, count: this.results.querySelectorAll('[data-destacados-card]').length });
        }
        return true;
      } catch (_) {
        if (request !== this.request) return false;
        status.textContent = '';
        error.querySelector('p').textContent = this.dataset.loadError;
        error.querySelector('[data-selection-fallback]').href = url.href;
        error.hidden = false;
        return false;
      } finally {
        window.clearTimeout(timeout);
        if (request === this.request) {
          this.results.setAttribute('aria-busy', 'false');
          status.dataset.loading = 'false';
        }
      }
    }
    updateSelection() {
      this.buttons.forEach(button => button.setAttribute('aria-current', String(button.dataset.selection === this.selection)));
      this.revealSelection();
      const count = this.results.querySelectorAll('[data-destacados-card]').length;
      const counter = this.results.querySelector('[data-destacados-count]');
      counter.textContent = this.dataset.countTemplate.replace('[count]', String(count)).replace('[total]', this.results.dataset.total);
      const next = this.results.querySelector('[data-selection-more]');
      if (next) {
        const url = this.cleanURL(next.href);
        url.searchParams.set('view', this.selection === 'vendidos' ? 'destacados-cro' : 'destacados-cro-' + this.selection);
        next.href = url.href;
      }
    }
    async restoreSelection() {
      try {
        const saved = JSON.parse(sessionStorage.getItem('ingenio-destacados-return') || 'null');
        if (!saved || Date.now() - saved.time > 1800000 || this.cleanURL(saved.url).href !== this.baseURL.href) return;
        sessionStorage.removeItem('ingenio-destacados-return');
        for (let index = 0; index < saved.pages.length; index += 1) {
          const next = this.results.querySelector('[data-selection-more]');
          if (!next || !await this.loadSelection(next.href, { append: true, history: false, restoring: true })) return;
        }
        window.scrollTo(0, saved.scrollY);
      } catch (_) { /* Storage is optional; the server-rendered selection remains usable. */ }
    }
    trackProduct(event, element) {
      const card = element.closest('[data-destacados-card]');
      if (card) this.track(event, { intent: this.selection, selection: this.selection, product_id: card.dataset.productId, position: Number(card.dataset.position) });
    }
    track(event, properties) {
      window.IngenioCRO?.track(event, { landing_version: 'destacados_A_v7', ...properties });
    }
    syncReviews() {
      const reviews = this.querySelector('.idc-reviews__app .jdgm-carousel-item');
      const score = Number(this.querySelector('.jdgm-all-reviews-rating')?.dataset.score);
      const count = Number(this.querySelector('.jdgm-carousel-number-of-reviews')?.dataset.numberOfReviews);
      const summary = this.querySelector('.jdgm-carousel-number-of-reviews a');
      if (summary && score > 0 && count > 0) {
        const locale = document.documentElement.lang || 'es';
        const text = this.dataset.ratingTemplate.replace('[rating]', score.toLocaleString(locale, { maximumFractionDigits: 2 })).replace('[count]', count.toLocaleString(locale));
        if (summary.textContent !== text) summary.textContent = text;
        const proof = this.querySelector('[data-review-summary]');
        const scoreLabel = proof?.querySelector('[data-review-score]');
        const totalLabel = proof?.querySelector('[data-review-total]');
        const scoreText = score.toLocaleString(locale, { maximumFractionDigits: 2 });
        if (scoreLabel && scoreLabel.textContent !== scoreText) scoreLabel.textContent = scoreText;
        if (totalLabel && totalLabel.textContent !== text) totalLabel.textContent = text;
        if (proof) proof.hidden = false;
      }
      this.querySelector('.jdgm-carousel__left-arrow')?.setAttribute('aria-label', this.dataset.reviewPrevious);
      this.querySelector('.jdgm-carousel__right-arrow')?.setAttribute('aria-label', this.dataset.reviewNext);
      this.querySelector('[data-destacados-review-fallback]').hidden = Boolean(reviews);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-hotsale"] && !Shopify.designMode) return;
  try {
    
(() => {
  const featured = ["8660567916732","9056864305340","8918644490428","9056864207036","8918692331708","8591317598396","9265283924156","9265280450748","8591317041340","8591312748732","8653124468924","8696538267836","8591309406396","8591458959548","8591312486588","8591349153980","9056859979964","8591320350908","8591342993596","9265274912956","9056878985404"];
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const bestsellers90d = ["8591317598396","9265283924156","9265280450748","8591317041340","9265274912956","8591458959548","9265283137724","9265275535548","9265277272252","8653112836284","9265442062524","9264455778492","8609400553660","9265279041724","9265272455356","9265460379836","8721663262908","8591312748732","8715636637884","9265274192060","8721661853884","9055093719228","9265432166588","9078580478140","9265443799228","9265421942972","8721676009660","9265282515132","8721678827708","8721665261756","9265475092668","8721691279548","8591327035580","8713516679356","8653138559164","8591370879164","8591311143100","9265449435324","8591325036732","9346772402364","9056860602556","8721689673916","9265439735996","8591325233340","8591351709884","8721675059388","9078579986620","8591330902204","9005068976316","8653116309692","9265475420348","8591321530556","8591309832380","8591312617660","8653124468924","8591426683068","9056873840828","8653127319740","8591321006268","8591458566332","8591368323260","9040631693500","8591372517564","8721672962236","9095218036924","9095222165692","8591399649468","8595353174204","8591342993596","8591320842428","8696538267836","8595353206972","9056859979964","8591348957372","8591426846908","9056875610300","9056875413692","8696537481404","9056861454524","9056861290684","8591321170108","8591325397180","8591321333948","8591320350908"];
  const discoveryProducts = ["8660567916732","9056864305340","8918644490428","9056864207036","8918692331708","9056859979964","8591372517564","8591309832380","9078580478140","9056878985404","8591450603708","8591370420412","8721663262908","8696538267836","9040631693500","8591312617660","8591327035580","9056879018172","8591439462588","8591378809020","8721661853884","8696537841852","8918633447612","8591309111484","9078579986620","9056879050940","8591436087484","8591370879164","8721676009660","9056860602556","8591349153980","8591309406396","8591330902204","8591321694396","8591311143100","8721665261756","9056873840828","9005068976316","8591309537468","8591368323260","8591341813948","8721678827708","9056861454524","8591342993596","8591312486588","9095222165692","8591456207036","8721691279548","9056861290684","8595353174204","8591309996220","9095218036924","8721689673916","9056875413692","8591320842428","8591309275324","8591399649468","8721675059388","9056875610300","8704065601724","8591325036732","9095211843772","8653124468924","8696537481404","8591317795004","8591325233340","9078582051004","8721672962236","9056860733628","8591426683068","8591351709884","8591396372668","8715636637884","8696536236220","8591348957372","8591458566332","8591396536508","9265282515132","9056860569788","8591426846908","8591325397180","8653138559164","8696519917756","8595353206972","8591310291132","8713516679356","8696536039612","8591312748732","9055093719228","8696537317564","8591321530556","9265443799228","9056874070204","8591321170108","9265475092668","9056869449916","8744418443452","9265449435324","9056859455676","8591343124668","9265475420348","9056865550524","8591321006268","8653116309692","9056859488444","9346772402364","8653127319740","9056868892860","8591320350908","9265274192060","9056861782204","8591321333948","9265432166588","9056861388988","8591426519228","9265421942972","8696536268988","9265439735996","9056858734780","9056865779900","8696536432828","9056858898620","9056878854332","9056868401340","8696538038460","9056861487292","9056861225148","9056858800316","9056858144956"];
  function merchandiseAll(items, fallbackRank) {
    const availableItems = items.filter(card => card.dataset.available === 'true');
    const byId = new Map(availableItems.map(card => [card.dataset.productId, card]));
    const remaining = new Set(availableItems);
    const sellers = bestsellers90d.map(id => byId.get(id)).filter(Boolean);
    const discoveries = discoveryProducts.map(id => byId.get(id)).filter(Boolean);
    const ordered = [];
    const add = card => {if (card && remaining.delete(card)) ordered.push(card);};
    while (sellers.some(card => remaining.has(card))) {
      const block = sellers.filter(card => remaining.has(card)).slice(0, 3);
      block.forEach(add);
      const categories = new Set(block.map(card => card.dataset.category));
      const discovery = discoveries.find(card => remaining.has(card) && !categories.has(card.dataset.category)) || discoveries.find(card => remaining.has(card));
      add(discovery);
    }
    discoveries.forEach(add);
    [...remaining].sort((a,b) => fallbackRank(a) - fallbackRank(b)).forEach(add);
    ordered.push(...items.filter(card => card.dataset.available !== 'true').sort((a,b) => fallbackRank(a) - fallbackRank(b)));
    return ordered;
  }
  function setup(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-hs-grid]');
    const cards = [...root.querySelectorAll('[data-hs-card]')];
    const search = root.querySelector('[data-hs-search]');
    const sort = root.querySelector('[data-hs-sort]');
    const available = root.querySelector('[data-hs-available]');
    const more = root.querySelector('[data-hs-more]');
    const count = root.querySelector('[data-hs-count]');
    let category = 'all', limit = 24;
    const rank = card => {const position = featured.indexOf(card.dataset.productId);return position < 0 ? 100 + Number(card.dataset.position) : position;};
    function update() {
      const query = normalize(search.value.trim());
      const matches = cards.filter(card => (category === 'all' || card.dataset.category === category) && (!available.checked || card.dataset.available === 'true') && normalize(card.dataset.search).includes(query));
      if (category === 'all' && sort.value === 'featured') {
        matches.splice(0, matches.length, ...merchandiseAll(matches, rank));
      } else matches.sort((a,b) => {
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'discount') return Number(b.dataset.discount) - Number(a.dataset.discount) || rank(a) - rank(b);
        return Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true') || rank(a) - rank(b);
      });
      cards.forEach(card => {card.hidden = true;});
      matches.forEach((card,index) => {grid.append(card);card.hidden = index >= limit;});
      count.textContent = matches.length === 1 ? root.dataset.oneLabel : root.dataset.countLabel.replace('[count]',String(matches.length));
      more.hidden = matches.length <= limit;
      root.querySelector('[data-hs-empty]').hidden = matches.length !== 0;
      root.querySelectorAll('[data-hs-category]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.hsCategory === category)));
    }
    root.querySelector('[data-hs-controls]').hidden = false;
    root.querySelectorAll('[data-hs-category]').forEach(button => button.addEventListener('click',() => {category = button.dataset.hsCategory;limit = 24;update();}));
    search.addEventListener('input',() => {limit=24;update();});
    sort.addEventListener('change',() => {limit=24;update();});
    available.addEventListener('change',() => {limit=24;update();});
    more.addEventListener('click',() => {const previous=limit;limit+=24;update();const visible=cards.filter(card=>!card.hidden).sort((a,b)=>[...grid.children].indexOf(a)-[...grid.children].indexOf(b));visible[previous]?.querySelector('a')?.focus({preventScroll:true});});
    root.querySelector('[data-hs-reset]').addEventListener('click',() => {category='all';limit=24;search.value='';sort.value='featured';available.checked=false;update();search.focus();});
    update();
    const serverNow=Number(root.dataset.now)*1000;
    const start=Number(root.dataset.start)*1000;
    const end=Number(root.dataset.end)*1000;
    const began=performance.now();
    const originalPhase=root.dataset.phase;
    let refreshing=false;
    const tick=() => {
      if (!root.isConnected) {clearInterval(interval);return;}
      const now=serverNow+performance.now()-began;
      const phase=now<start?'upcoming':now<end?'active':'ended';
      if (phase!==originalPhase && !refreshing) {refreshing=true;window.location.reload();return;}
      const remaining=Math.max(0,Math.floor(((phase==='upcoming'?start:end)-now)/1000));
      const units={days:Math.floor(remaining/86400),hours:Math.floor(remaining%86400/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};
      Object.entries(units).forEach(([key,value])=>{const node=root.querySelector('[data-hs-'+key+']');if(node)node.textContent=String(value).padStart(2,'0');});
    };
    const interval=setInterval(tick,1000);tick();
  }
  document.querySelectorAll('[data-hotsale]').forEach(setup);
  document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-hotsale]').forEach(setup);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-journal-2026"]) return;
  try {
    
(() => {
  const initializeJournal = (root) => {
    if (root.dataset.journalReady || root.dataset.serverPage !== '1' || Number(root.dataset.legacyFilter) > 0) return;
    const grid = root.querySelector('[data-journal-enhanced-grid]');
    const groups = root.querySelector('[data-journal-native-groups]');
    const heading = root.querySelector('[data-journal-heading]');
    const headingRow = heading?.parentElement;
    const defaultHeading = heading?.textContent || '';
    const pageLabel = root.querySelector('[data-journal-page-label]');
    const status = root.querySelector('[data-journal-status]');
    const retry = root.querySelector('[data-journal-retry]');
    const pagination = root.querySelector('[data-journal-pagination]');
    const nativePagination = root.querySelector('[data-journal-native-pagination]');
    const feature = root.querySelector('[data-journal-feature]');
    const links = [...root.querySelectorAll('[data-category-link]')];
    if (!grid || !groups || !heading || !status || !pagination) return;
    root.dataset.journalReady = 'true';
    const items = new Map();
    const pageSize = Number(root.dataset.pageSize) || 10;
    let nextPage = root.dataset.nextPage || '';
    let complete = !nextPage;
    let loading = null;
    let requestVersion = 0;
    let selectedCategory = 'all';
    let selectedPage = 1;
    let pendingChoice = null;
    const labels = new Map(links.map((link) => [link.dataset.categoryLink, link.textContent.trim()]));
    const addCards = (source) => {
      source.querySelectorAll('[data-journal-card]').forEach((card) => {
        if (!items.has(card.dataset.articleId)) {
          items.set(card.dataset.articleId, card);
          card.hidden = true;
          grid.appendChild(card);
        }
      });
    };
    addCards(groups);
    groups.hidden = true;
    grid.hidden = false;
    if (nativePagination) nativePagination.hidden = true;
    const sortedCards = () => [...items.values()].sort((a, b) => Number(b.dataset.date) - Number(a.dataset.date) || Number(b.dataset.articleId) - Number(a.dataset.articleId));
    const linkFor = (category, page) => {
      const url = new URL(window.location.href);
      url.hash = new URLSearchParams({ tema: category, pagina: String(page) }).toString();
      return url.pathname + url.search + url.hash;
    };
    const parseLocation = () => {
      const params = new URLSearchParams(window.location.hash.slice(1));
      let category = params.get('tema');
      if (!category) category = links.find((link) => link.dataset.categoryLink !== 'all' && window.location.hash.endsWith('-' + link.dataset.categoryLink))?.dataset.categoryLink;
      return { category: labels.has(category) ? category : 'all', page: Math.max(1, Number(params.get('pagina')) || 1) };
    };
    const makePageLink = (text, category, page, active = false, direction = false) => {
      const link = document.createElement('a');
      link.href = linkFor(category, page);
      link.textContent = text;
      link.dataset.journalPage = String(page);
      if (active) link.setAttribute('aria-current', 'page');
      if (direction) link.className = 'ip-journal__page-direction';
      return link;
    };
    const render = (category, page, focus) => {
      selectedCategory = labels.has(category) ? category : 'all';
      const matching = sortedCards().filter((card) => selectedCategory === 'all' || card.dataset.category === selectedCategory);
      const total = selectedCategory === 'all' && !complete ? Number(root.dataset.total) || matching.length : matching.length;
      const pageCount = Math.max(1, Math.ceil(total / pageSize));
      selectedPage = Math.min(Math.max(1, page), pageCount);
      const visible = matching.slice((selectedPage - 1) * pageSize, selectedPage * pageSize);
      const visibleIds = new Set(visible.map((card) => card.dataset.articleId));
      const showFeature = Boolean(feature && selectedCategory === 'all' && selectedPage === 1 && visibleIds.has(feature.dataset.featureId));
      if (feature) feature.hidden = !showFeature;
      for (const card of sortedCards()) {
        card.hidden = !visibleIds.has(card.dataset.articleId) || (showFeature && card.dataset.articleId === feature.dataset.featureId);
        grid.appendChild(card);
      }
      heading.textContent = selectedCategory === 'all' ? defaultHeading : labels.get(selectedCategory);
      status.textContent = total ? root.dataset.countFormat.replace('__COUNT__', String(total)) : root.dataset.empty;
      pageLabel.textContent = pageCount > 1 ? root.dataset.pageFormat.replace('__CURRENT__', String(selectedPage)).replace('__TOTAL__', String(pageCount)) : '';
      links.forEach((link) => {
        if (link.dataset.categoryLink === selectedCategory) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        if (complete && link.dataset.categoryLink !== 'all') link.parentElement.hidden = ![...items.values()].some((card) => card.dataset.category === link.dataset.categoryLink);
      });
      pagination.replaceChildren();
      pagination.hidden = pageCount <= 1;
      if (pageCount > 1) {
        if (selectedPage > 1) pagination.appendChild(makePageLink('← ' + root.dataset.previous, selectedCategory, selectedPage - 1, false, true));
        const list = document.createElement('ul');
        list.setAttribute('role', 'list');
        const pages = new Set([1, pageCount, selectedPage - 1, selectedPage, selectedPage + 1].filter((number) => number >= 1 && number <= pageCount));
        let last = 0;
        [...pages].sort((a, b) => a - b).forEach((number) => {
          if (last && number - last > 1) {
            const gap = document.createElement('li');
            const span = document.createElement('span');
            span.textContent = '…';
            gap.appendChild(span);
            list.appendChild(gap);
          }
          const item = document.createElement('li');
          item.appendChild(makePageLink(String(number), selectedCategory, number, number === selectedPage));
          list.appendChild(item);
          last = number;
        });
        pagination.appendChild(list);
        if (selectedPage < pageCount) pagination.appendChild(makePageLink(root.dataset.next + ' →', selectedCategory, selectedPage + 1, false, true));
      }
      retry.hidden = true;
      if (focus && headingRow) {
        headingRow.focus({ preventScroll: true });
        headingRow.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    };
    const loadAll = async () => {
      if (complete) return;
      if (loading) return loading;
      loading = (async () => {
        const visited = new Set();
        while (nextPage) {
          if (visited.has(nextPage)) throw new Error('Repeated blog index page');
          visited.add(nextPage);
          const url = new URL(nextPage, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Unexpected blog index origin');
          url.searchParams.set('section_id', root.dataset.sectionId);
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Blog index unavailable');
          const html = await response.text();
          const page = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-journal-index]');
          if (!page || page.dataset.sectionId !== root.dataset.sectionId) throw new Error('Unexpected blog index response');
          addCards(page);
          nextPage = page.dataset.nextPage || '';
        }
        complete = true;
      })();
      try { await loading; } finally { loading = null; }
    };
    const apply = async (choice, focus = false, updateLocation = false) => {
      pendingChoice = choice;
      const version = ++requestVersion;
      root.setAttribute('aria-busy', 'true');
      retry.hidden = true;
      try {
        if (!complete) {
          status.textContent = root.dataset.loading;
          await loadAll();
        }
        if (version !== requestVersion) return;
        render(choice.category, choice.page, focus);
        if (updateLocation) history.pushState({}, '', linkFor(selectedCategory, selectedPage));
      } catch {
        if (version !== requestVersion) return;
        status.textContent = root.dataset.error;
        retry.hidden = false;
        if (nativePagination) nativePagination.hidden = false;
      } finally {
        if (version === requestVersion) root.removeAttribute('aria-busy');
      }
    };
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-category-link],[data-journal-page]');
      if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      const category = link.dataset.categoryLink || selectedCategory;
      const page = Number(link.dataset.journalPage) || 1;
      apply({ category, page }, true, true);
    });
    retry.addEventListener('click', () => { if (pendingChoice) apply(pendingChoice, true, true); });
    const restoreLocation = () => apply(parseLocation(), false, false);
    window.addEventListener('popstate', restoreLocation);
    window.addEventListener('hashchange', restoreLocation);
    const initial = parseLocation();
    render('all', 1, false);
    if (initial.category !== 'all' || initial.page !== 1) apply(initial, false, false);
  };
  document.querySelectorAll('[data-journal-index]').forEach(initializeJournal);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-journal-index]').forEach(initializeJournal));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-launch-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ingenioLaunchTrackingBound) return;
    window.ingenioLaunchTrackingBound = true;
    const track = (event, data) => window.ingenioLaunchTrack?.(event, data);
    const observed = new WeakSet();
    const counted = new WeakSet();
    const view = section => {
      if (counted.has(section)) return;
      if (track('ingenio_collection_view', { page_type: section.dataset.pageType })) counted.add(section);
    };
    const observe = () => {
      document.querySelectorAll('[data-ingenio-launch]').forEach(section => {
        if (section.dataset.preview === 'true') return;
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) view(section);
        if (observed.has(section)) return;
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            view(section);
            if (counted.has(section)) observer.disconnect();
          }
        }, { threshold: .05 });
        observer.observe(section);
        observed.add(section);
      });
    };
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-ingenio-event]');
      if (!link || link.closest('[data-preview="true"]')) return;
      track(link.dataset.ingenioEvent, { intent: link.dataset.intent, product_id: link.dataset.productId });
    });
    document.addEventListener('shopify:section:load', observe);
    document.addEventListener('ingenio:analytics-ready', observe);
    document.addEventListener('visitorConsentCollected', observe);
    observe();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingenio-reviews-2026"]) return;
  try {
    
(() => {
  const bindReviews = (root) => {
    root.querySelectorAll('.ip-reviews__more').forEach((details) => {
      if (details.dataset.reviewsBound) return;
      details.dataset.reviewsBound = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      });
    });
  };
  bindReviews(document);
  document.addEventListener('shopify:section:load', (event) => bindReviews(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-personalizado-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('personalized-product-v2')) {
    customElements.define(
      'personalized-product-v2',
      class PersonalizedProductV2 extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-personalizado-variants]').textContent);
          this.optionInputs = Array.from(this.querySelectorAll('[data-personalizado-option]'));
          this.variantInput = this.querySelector('input[name="id"]');
          this.price = this.querySelector('[data-personalizado-price]');
          this.pricePrefix = this.querySelector('[data-personalizado-price-prefix]');
          this.comparePrice = this.querySelector('[data-personalizado-compare]');
          this.selection = this.querySelector('[data-personalizado-selection]');
          this.submit = this.querySelector('[data-personalizado-submit]');
          this.submitLabel = this.querySelector('[data-personalizado-submit-label]');
          this.headerWrapper = document.querySelector('.section-header .header-wrapper');
          this.updateHeaderClearance = this.updateHeaderClearance.bind(this);

          this.updateHeaderClearance();
          requestAnimationFrame(this.updateHeaderClearance);
          window.addEventListener('resize', this.updateHeaderClearance);
          if (this.headerWrapper && 'ResizeObserver' in window) {
            this.headerResizeObserver = new ResizeObserver(this.updateHeaderClearance);
            this.headerResizeObserver.observe(this.headerWrapper);
          }

          this.optionInputs.forEach((input) => input.addEventListener('change', () => this.updateVariant()));
          this.querySelectorAll('[data-personalizado-media]').forEach((button) => {
            button.addEventListener('click', () => this.selectMedia(button));
          });

          const selectedVariantId = Number(this.dataset.selectedVariantId || 0);
          if (selectedVariantId) {
            const selectedVariant = this.variants.find((variant) => Number(variant.id) === selectedVariantId);
            if (selectedVariant) this.selectVariantOptions(selectedVariant);
          }

          if (this.variants.length === 1) {
            this.applyVariant(this.variants[0]);
          } else {
            this.updateVariant();
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.updateHeaderClearance);
          if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
        }

        updateHeaderClearance() {
          if (!this.headerWrapper) return;
          const headerSection = this.headerWrapper.closest('.section-header');
          const isCoverHeader = headerSection && headerSection.classList.contains('shopify-section-header-cover');
          let clearance = 0;

          if (isCoverHeader) {
            const wrapperTop = Number.parseFloat(window.getComputedStyle(this.headerWrapper).top) || 0;
            clearance = Math.max(0, Math.ceil(wrapperTop + this.headerWrapper.offsetHeight));
          } else if (window.scrollY < 2) {
            const headerBottom = this.headerWrapper.getBoundingClientRect().bottom;
            const sectionTop = this.getBoundingClientRect().top;
            clearance = Math.max(0, Math.ceil(headerBottom - sectionTop));
          }

          this.style.setProperty('--personalizado-v2-header-clearance', `${clearance}px`);
        }

        selectVariantOptions(variant) {
          variant.options.forEach((value, index) => {
            const input = this.optionInputs.find(
              (candidate) => Number(candidate.dataset.optionPosition) === index + 1 && candidate.value === value
            );
            if (input) input.checked = true;
          });
          this.updateVariant();
        }

        selectedOptions() {
          const selected = [];
          this.optionInputs.forEach((input) => {
            if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
          });
          return selected;
        }

        updateVariant() {
          const selected = this.selectedOptions();
          const optionCount = this.querySelectorAll('fieldset[data-option-position]').length;
          const isComplete = selected.filter(Boolean).length === optionCount;
          const variant = isComplete
            ? this.variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]))
            : null;

          this.updateOptionAvailability(selected);
          this.applyVariant(variant);
        }

        updateOptionAvailability(selected) {
          this.optionInputs.forEach((input) => {
            const hypothetical = [...selected];
            hypothetical[Number(input.dataset.optionPosition) - 1] = input.value;
            const possible = this.variants.some(
              (variant) => variant.available && hypothetical.every((value, index) => !value || variant.options[index] === value)
            );
            input.disabled = !possible && !input.checked;
          });
        }

        applyVariant(variant) {
          if (!variant) {
            this.variantInput.value = '';
            this.submit.disabled = true;
            this.submitLabel.textContent = this.dataset.selectionLabel;
            if (this.selection) {
              this.selection.textContent = this.dataset.selectionMessage;
              this.selection.hidden = true;
            }
            this.pricePrefix.hidden = false;
            this.comparePrice.hidden = true;
            return;
          }

          this.variantInput.value = variant.id;
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.price.textContent = variant.formattedPrice;
          this.pricePrefix.hidden = true;
          if (this.selection) {
            this.selection.textContent = variant.title;
            this.selection.hidden = false;
          }

          if (variant.compareAtPrice > variant.price) {
            this.comparePrice.textContent = variant.formattedCompareAtPrice;
            this.comparePrice.hidden = false;
          } else {
            this.comparePrice.hidden = true;
          }

          if (variant.available) {
            this.submit.disabled = false;
            this.submitLabel.textContent = `${this.dataset.addLabel} — ${variant.formattedPrice}`;
          } else {
            this.submit.disabled = true;
            this.submitLabel.textContent = this.dataset.soldOutLabel;
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        selectMedia(button) {
          const image = this.querySelector('.personalizado-v2__main-image');
          if (!image) return;
          image.removeAttribute('srcset');
          image.src = button.dataset.src;
          image.alt = button.dataset.alt || '';
          this.querySelectorAll('[data-personalizado-media]').forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            if (active) candidate.setAttribute('aria-current', 'true');
            else candidate.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-faq-closing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-personalized-sticky]').forEach((sticky) => {
    const hero = document.querySelector('[data-personalized-hero]');
    const targetSelector = sticky.getAttribute('href');
    const target = targetSelector ? document.querySelector(targetSelector) : null;
    let heroVisible = true;
    let targetVisible = false;

    const update = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !targetVisible);
    };

    if (hero && 'IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver((entries) => {
        heroVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.08 });
      heroObserver.observe(hero);
    }

    if (target && 'IntersectionObserver' in window) {
      const targetObserver = new IntersectionObserver((entries) => {
        targetVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 });
      targetObserver.observe(target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-v2-proof-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-personalized-v2-sticky]').forEach((sticky) => {
    const hero = document.querySelector('[data-personalized-v2-hero]');
    const selector = document.querySelector('#personalizados-v2-selector');
    let heroVisible = true;
    let selectorVisible = false;

    const update = () => {
      sticky.classList.toggle('is-visible', !heroVisible && !selectorVisible);
    };

    if (hero) {
      new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
        update();
      }, { threshold: 0.08 }).observe(hero);
    } else {
      heroVisible = false;
    }

    if (selector) {
      new IntersectionObserver(([entry]) => {
        selectorVisible = entry.isIntersecting;
        update();
      }, { threshold: 0.02 }).observe(selector);
    }

    update();
  });

  } catch(e) { console.error(e); }
})();
})();
